export default {
  0: { hasBorder: true },
  1: { minimalistic: true },
  2: { hasBorder: true, publishedDate: true },
};
